import { useMemo } from 'react';
import { CNA_TABS } from '../../constants';
import PageTabs from '../../../../components/other/page-tabs';
import React from 'react';
import { useAuth } from '../../../../container/authContext';
import { usePermission } from '../../../../container/permissionContext';

const Header = () => {
  const { user = {} } = useAuth();
  const { isSuperAdmin, isCompanySystemAdministrator, hasPermissionByCodeName } = usePermission();

  const { is_unit_user } = user;
  let layout = null;

  const tabs = useMemo(() => {
    if (isSuperAdmin() || isCompanySystemAdministrator()) {
      return CNA_TABS;
    }

    const tempTabs = [];

    if (hasPermissionByCodeName('cna_templates_management') || hasPermissionByCodeName('manage_cna_assignments')) {
      tempTabs.push(CNA_TABS[0]);
    }

    if (hasPermissionByCodeName('cna_tasks_management')) {
      tempTabs.push(CNA_TABS[1]);
    }

    return tempTabs;
  }, [user, isSuperAdmin, isCompanySystemAdministrator]);

  if (!is_unit_user) {
    layout = <PageTabs tabs={tabs} />;
  }
  return layout;
};

export default Header;
